import actionTypes from 'dashboard/actions/site-financial-status/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SITE_FINANCIAL_STATUS_SUCCESS:
      return { ...action.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/site-financial-status/site-financial-status.js